const paidQuoteReport = {
  label: "Paid Quote Report",
  name: "paidQuoteReport",
  parameters: [
    {
      name: "agency",
      label: "Agency",
      type: "dbfield",
      db: "data",
      table: "Program",
      keyField: "ProgramAssociatedId",
      valueField: "ProgramAssociatedId",
      fields: ["Program.ProgramAssociatedId"],
      distinct: true,
      where: {
        ProgramAssociatedId: {
          null: false,
        },
      },
      sort: {
        ProgramAssociatedId: "asc",
      },
    },
  ],
};

export default paidQuoteReport;
